module.exports = function (app, mod, discard) {
  var html = "\n    <div class=\"saitoa discard-cards-overlay\">\n      <div class=\"settlers-items-container\">\n        <div class=\"settlers-item-info-text\"> Select ".concat(discard.targetCt, " cards to discard: </div> ");
  for (var i in discard.my_resources) {
    if (discard.my_resources[i] > 0) html += "<div id=\"".concat(i, "\" class=\"settlers-cards-container settlers-desired-resources hide-scrollbar\">");
    for (var j = 0; j < discard.my_resources[i]; j++) {
      html += "<img id=\"".concat(i, "\" src=\"").concat(mod.returnCardImage(i), "\">");
    }
    html += "</div>";
  }
  html += "\n      </div>\n    </div>\n  ";
  return html;
};